import React, { useEffect, useState } from "react";
import { adminApi } from "@/admin/adminApi";
import { Skeleton } from "@/components/ui/skeleton";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Audit() {
  const [items, setItems] = useState(null);
  useEffect(() => { adminApi.get("/audit").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div data-testid="admin-audit">
      <div className="mb-5"><h1 className="font-display text-2xl">Activity Log</h1><p className="text-sm text-wp-ink-muted">Recent admin actions.</p></div>
      <div className="overflow-hidden rounded-wp-lg border border-border bg-card shadow-wp-soft">
        {items === null ? <div className="space-y-2 p-4">{[...Array(5)].map((_, i) => <Skeleton key={i} className="h-10 w-full" />)}</div>
          : items.length === 0 ? <div className="p-10 text-center text-wp-ink-muted">No activity yet.</div>
          : (
            <Table>
              <TableHeader><TableRow><TableHead>Action</TableHead><TableHead>Target</TableHead><TableHead>By</TableHead><TableHead>When</TableHead></TableRow></TableHeader>
              <TableBody>
                {items.map((a) => (
                  <TableRow key={a.id}>
                    <TableCell><Badge className="border-0 bg-wp-blush-100 text-wp-rose-strong capitalize">{(a.action || "").replace(/_/g, " ")}</Badge></TableCell>
                    <TableCell className="text-sm text-wp-ink-muted">{a.target || "—"}{a.detail ? ` · ${a.detail}` : ""}</TableCell>
                    <TableCell className="text-sm">{a.admin_email}</TableCell>
                    <TableCell className="text-sm text-wp-ink-muted">{a.created_at ? new Date(a.created_at).toLocaleString() : "—"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
      </div>
    </div>
  );
}
